import { DatePickerProps } from '@shared/components/date-picker/DatePicker';
import { DropdownQueryParam } from 'clerk_common/constants/urls/queryParams';
import {
  toEndOfDayUTC,
  toStartOfDayUTC,
  utcDateStringToLocalDate,
} from 'clerk_common/stringification/dates';
import { useEffect, useMemo, useState } from 'react';
import { CalendarProps } from 'react-calendar';
import useFilters from '../data-table-filters/hooks/useFilters';

export function useDateRangeFilter({
  startParam,
  endParam,
}: {
  startParam?: DropdownQueryParam;
  endParam?: DropdownQueryParam;
}) {
  const { getMinMaxAmount, setMinMaxAmount, clearFilters } = useFilters();

  const startQuery = startParam ? getMinMaxAmount(startParam) : undefined;
  const endQuery = endParam ? getMinMaxAmount(endParam) : undefined;

  const start = useMemo(
    () =>
      startQuery
        ? utcDateStringToLocalDate(decodeURIComponent(startQuery))
        : new Date(),
    [startQuery]
  );
  const end = useMemo(
    () =>
      endQuery
        ? utcDateStringToLocalDate(decodeURIComponent(endQuery))
        : new Date(),
    [endQuery]
  );
  const [dateRange, setDateRange] = useState<DatePickerProps['values']>([
    start,
    end,
  ]);

  useEffect(() => {
    setDateRange([start, end]);
  }, [start, end]);

  const submitDateRange = async (newDate: CalendarProps['value']) => {
    if (
      Array.isArray(newDate) &&
      newDate[0] !== null &&
      newDate[1] !== null &&
      startParam &&
      endParam
    ) {
      await setMinMaxAmount({
        checked: true,
        minAmount: encodeURIComponent(toStartOfDayUTC(new Date(newDate[0]))),
        maxAmount: encodeURIComponent(toEndOfDayUTC(new Date(newDate[1]))),
        minParam: startParam,
        maxParam: endParam,
      });
    }
  };

  const clearDateRange = async () => {
    setDateRange([null, null]);
    if (startParam && endParam) {
      await clearFilters([startParam, endParam]);
    }
  };

  return {
    clearDateRange,
    dateRange,
    setDateRange,
    submitDateRange,
  };
}
